// Header JavaScript Functions
class HeaderManager {
  constructor() {
    this.searchForm = document.querySelector('.search-form');
    this.searchInput = document.querySelector('.search-input');
    this.cartIcon = document.querySelector('.cart-icon');
    this.menuItems = document.querySelectorAll('.has-dropdown');
    
    this.init();
  }

  init() {
    this.setupSearch();
    this.setupMobileMenu();
    this.setupDropdowns();
    this.setupStickyHeader();
    this.setupCartUpdates();
  }

  // Search functionality
  setupSearch() {
    if (this.searchForm) {
      this.searchForm.addEventListener('submit', (e) => {
        if (!this.searchInput.value.trim()) {
          e.preventDefault();
          this.searchInput.focus();
        }
      });

      // Search suggestions (optional)
      this.searchInput.addEventListener('input', this.debounce((e) => {
        this.handleSearchSuggestions(e.target.value);
      }, 300));
    }
  }

  // Handle search suggestions
  handleSearchSuggestions(query) {
    if (query.length < 2) return;
    
    // This would integrate with Shopify's search API
    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
      .then(response => response.json())
      .then(data => {
        this.displaySearchSuggestions(data);
      })
      .catch(error => {
        console.error('Search error:', error);
      });
  }

  // Display search suggestions
  displaySearchSuggestions(data) {
    let suggestionsContainer = document.querySelector('.search-suggestions');
    
    if (!suggestionsContainer) {
      suggestionsContainer = document.createElement('div');
      suggestionsContainer.className = 'search-suggestions';
      this.searchForm.appendChild(suggestionsContainer);
    }

    if (data.resources && data.resources.results && data.resources.results.products) {
      const products = data.resources.results.products;
      const suggestionsHTML = products.map(product => `
        <a href="${product.url}" class="suggestion-item">
          <img src="${product.featured_image}" alt="${product.title}" class="suggestion-image">
          <div class="suggestion-content">
            <span class="suggestion-title">${product.title}</span>
            <span class="suggestion-price">${product.price}</span>
          </div>
        </a>
      `).join('');
      
      suggestionsContainer.innerHTML = suggestionsHTML;
      suggestionsContainer.style.display = 'block';
    } else {
      suggestionsContainer.style.display = 'none';
    }
  }

  // Mobile menu setup
  setupMobileMenu() {
    // Create mobile menu toggle
    const mobileToggle = document.createElement('button');
    mobileToggle.className = 'mobile-menu-toggle';
    mobileToggle.innerHTML = `
      <span></span>
      <span></span>
      <span></span>
    `;
    
    const headerMain = document.querySelector('.header-main .container');
    if (headerMain) {
      headerMain.appendChild(mobileToggle);
    }

    // Toggle mobile menu
    mobileToggle.addEventListener('click', () => {
      const nav = document.querySelector('.header-nav');
      nav.classList.toggle('mobile-active');
      mobileToggle.classList.toggle('active');
    });

    // Close mobile menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.header-nav') && !e.target.closest('.mobile-menu-toggle')) {
        document.querySelector('.header-nav')?.classList.remove('mobile-active');
        mobileToggle.classList.remove('active');
      }
    });
  }

  // Dropdown menus
  setupDropdowns() {
    this.menuItems.forEach(item => {
      const dropdown = item.querySelector('.dropdown-menu');
      
      if (dropdown) {
        item.addEventListener('mouseenter', () => {
          dropdown.style.display = 'block';
          setTimeout(() => {
            dropdown.classList.add('show');
          }, 10);
        });

        item.addEventListener('mouseleave', () => {
          dropdown.classList.remove('show');
          setTimeout(() => {
            dropdown.style.display = 'none';
          }, 300);
        });
      }
    });
  }

  // Sticky header
  setupStickyHeader() {
    const header = document.querySelector('.site-header');
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > 100) {
        header.classList.add('scrolled');
        
        if (currentScrollY > lastScrollY) {
          header.classList.add('hide');
        } else {
          header.classList.remove('hide');
        }
      } else {
        header.classList.remove('scrolled', 'hide');
      }
      
      lastScrollY = currentScrollY;
    });
  }

  // Cart updates
  setupCartUpdates() {
    // Listen for cart updates
    document.addEventListener('cart:updated', (e) => {
      this.updateCartCount(e.detail.itemCount || 0);
    });

    // Initial cart count
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this.updateCartCount(cart.item_count);
      })
      .catch(error => {
        console.error('Cart fetch error:', error);
      });
  }

  // Update cart count
  updateCartCount(count) {
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      cartCount.textContent = count;
      cartCount.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  // Utility function for debouncing
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Additional CSS for mobile and interactive states
const additionalStyles = `
<style>
/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  gap: 3px;
}

.mobile-menu-toggle span {
  width: 25px;
  height: 3px;
  background: #333;
  transition: all 0.3s ease;
}

.mobile-menu-toggle.active span:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.mobile-menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* Search Suggestions */
.search-form {
  position: relative;
}

.search-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 1000;
  display: none;
}

.suggestion-item {
  display: flex;
  align-items: center;
  padding: 12px;
  text-decoration: none;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s ease;
}

.suggestion-item:hover {
  background: #f8f9fa;
}

.suggestion-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 12px;
}

.suggestion-content {
  display: flex;
  flex-direction: column;
}

.suggestion-title {
  font-weight: 500;
  margin-bottom: 2px;
}

.suggestion-price {
  color: #666;
  font-size: 14px;
}

/* Sticky Header States */
.site-header.scrolled {
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
}

.site-header.scrolled .header-top-bar {
  transform: translateY(-100%);
  opacity: 0;
}

.site-header.hide {
  transform: translateY(-100%);
}

.site-header {
  transition: all 0.3s ease;
}

.header-top-bar {
  transition: all 0.3s ease;
}

/* Dropdown Show State */
.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: flex;
  }
  
  .header-nav {
    position: fixed;
    top: 0;
    left: -100%;
    width: 80%;
    height: 100vh;
    background: white;
    transition: left 0.3s ease;
    z-index: 1001;
    overflow-y: auto;
  }
  
  .header-nav.mobile-active {
    left: 0;
  }
  
  .main-menu {
    flex-direction: column;
    padding: 20px;
    gap: 0;
  }
  
  .menu-link {
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .dropdown-menu {
    position: static;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    opacity: 1;
    visibility: visible;
    transform: none;
    background: #f8f9fa;
    margin-left: 20px;
  }
  
  .has-dropdown .dropdown-menu {
    display: none;
  }
  
  .has-dropdown.active .dropdown-menu {
    display: block;
  }
}

/* RTL Support */
[dir="rtl"] .header-content {
  direction: rtl;
}

[dir="rtl"] .search-form {
  direction: ltr;
}

[dir="rtl"] .main-menu {
  direction: rtl;
}
</style>
`;

// Initialize header when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Add additional styles to head
  document.head.insertAdjacentHTML('beforeend', additionalStyles);
  
  // Initialize header manager
  new HeaderManager();
});

// Shopify theme events
if (typeof Shopify !== 'undefined') {
  // Listen for cart drawer updates
  if (Shopify.theme) {
    Shopify.theme.cartUpdateCallbacks = Shopify.theme.cartUpdateCallbacks || [];
    Shopify.theme.cartUpdateCallbacks.push((cart) => {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { itemCount: cart.item_count }
      }));
    });
  }
}